import React, { useState } from "react";
import styled from "styled-components";
// Components
import BlogBox from "../Elements/BlogBox";
import ProfileModal from "../Elements/ProfileModal"; // if you made it
import { people } from "../../assets/team";

export default function Team() {
  // 👇 add this line
  const [selected, setSelected] = useState(null);

  return (
    <Wrapper id="team">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">ISRHB is a vast family</h1>
            <p className="font13">
              ISRHB has been established to serve destitute Hindus in
              Bangladesh. Everyone is equal here. “Work first, speak later” is
              our mantra. The directors are merely fulfilling the obligations
              necessary to constitute a lawful organization.
            </p>
          </HeaderInfo>

          <div className="row textCenter">
            {people.map((person) => (
              <div
                key={person.id || person.name}
                className="col-xs-12 col-sm-4 col-md-4 col-lg-4"
              >
                <BlogBox
                  title={person.name}
                  text={
                    person.description ||
                    "Lorem ipsum dolor sit amet, consetetur sadipscing elitr..."
                  }
                  tag={`Residence: ${person.country || "Unknown"}`}
                  author={person.role}
                  image={person.image}
                  onReadMore={() => setSelected(person)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Show modal when selected is set */}
      <ProfileModal person={selected} onClose={() => setSelected(null)} />

      <br />
    </Wrapper>
  );
}
const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
`;

const HeaderInfo = styled.div`
  margin-bottom: 30px;

  @media (max-width: 860px) {
    text-align: center;
  }
`;
